import React from 'react'
import Header from '../Layout/Header'
import Index from './Component/Index'
import Footer from '../Layout/Footer'
import SeoTagsFooter from './Component/SeoTagsFooter'

function Home() {
  return (
    <div className="page_wrapper">
        <Header/>
        <Index/>
        <Footer/>
        <SeoTagsFooter/>
    </div>
  )
}

export default Home